
// import app from "./app" 

export const elementPadding = function(padding) {  
    if (padding) {
        const values = padding.split(','); // Split the padding string into an array 
        return values.map((value) => `${value}px`).join(' '); // Convert and join the values
    } 
}

export const elementBackground = function(value, type, overlayColor) {
    if(value) {
      if(value !== "") {  
        if(overlayColor){
          // console.log("overlayColor ccc", overlayColor)
          const rgba = app.getColor(overlayColor);
          const overlayValue = `linear-gradient(${rgba}, ${rgba})`;
          if(type === "color") {
            // console.log("${overlayValue}, linear-gradient(${value}, ${value})", overlayValue, value)
            value = app.getColor(value);
            return `${overlayValue}, linear-gradient(${value}, ${value})`;
          }
          else if(type === "l_gradient") {
            return `${overlayValue}, linear-gradient(to bottom right, ${app.getColor(value.split("$$")[0])}, ${app.getColor(value.split("$$")[1])}) `;
          }
          else if(type === "pattern") {
            return `${overlayValue}, url(${app.cdn(value)}) repeat center / 20px 20px`;
          }
          return `${overlayValue}, url("${app.cdn(value)}") no-repeat center / cover`;
        }
        else{
          if(type === "color") {
            value = app.getColor(value);
            return `${value}`;
          }
          else if(type === "l_gradient") {
            return `linear-gradient(to bottom right, ${app.getColor(value.split("$$")[0])}, ${app.getColor(value.split("$$")[1])}) `;
          }
          else if(type === "pattern") {
            return `url(${app.cdn(value)}) repeat center / 20px 20px`;
          }else{
            return `url("${app.cdn(value)}") no-repeat center / cover`;
          } 
        }
       
      }
    }
    return "";
  }

const app = {
   getDevice:function() {
        const isWIndow =  typeof window === "undefined"
        if(!isWIndow){
          if(localStorage.getItem("device") === "mobile") {
            return false;
          }
        } 
        return  true;
     },
   getColor:function(argb){
        if(argb) {
          if(argb.length === 7) {
            return argb;
          }
          else {
            return argb.replace(argb.substr(1, 2), "") + argb.substr(1, 2);
          } 
        }
        return ""; 
      },
      getBorder:function(properties){
        let type = properties["borderType"];
        if(type === 'line'){
          type = "solid"
        }else if(type === 'dash'){
          type = "dashed"
        }
        if(properties["borderColor"]){
          return properties.borderSize+'px '+type+' '+app.getColor(properties["borderColor"]); 
        } 
        else {
          return "";
        }
      },
     
  getStyle:function(data, device) {
          const style = {};
          if(!data) {
            return style;
          }
          if(elementsStyle[data.viewType]) {
            elementsStyle[data.viewType].forEach(function(v){
              const value = data.properties[v.value];
              
              if(v.key === "fontFamily") {
                style[v.key] = value;  
              } 
              else if(v.key === "fontSize") {
                if(v.value === "iconSizeWeb") {
                  if(device === "desktop") {
                    if(data.properties["iconSizeWeb"] !== null){
                      style[v.key] = data.properties["iconSizeWeb"] + 'px';
                    } 
                  }
                  else {
                    if(data.properties["iconSize"] !== null){
                      style[v.key] = data.properties["iconSize"] + 'px';
                    } 
                  }
                }else{
                  if(device === "desktop") {
                    if(data.properties["textSizeWeb"] !== null){
                      style[v.key] = data.properties["textSizeWeb"] + 'px'; 
                    }  
                  }
                  else {
                    if(data.properties["textSize"] !== null){
                      style[v.key] = data.properties["textSize"] + 'px';
                    } 
                  }
                } 
              }
              else if(v.key === "color") {
                if(device === "desktop" && data.properties["iconColorWeb"] !== undefined){
                  style[v.key] = app.getColor(data.properties["iconColorWeb"]);
                }else{
                  style[v.key] = app.getColor(value);
                } 
              } 
              else if(v.key === "padding") { 
                if(device === "desktop") { 
                  style[v.key] = elementPadding(data.properties["paddingWeb"]);
                }
                else {
                  style[v.key] = elementPadding(data.properties["padding"]);
                }
              }
  
              else if(v.key === "margin") { 
                if(device === "desktop") { 
                  style[v.key] = elementPadding(data.properties["marginWeb"]);
                }
                else {
                  style[v.key] = elementPadding(data.properties["margin"]);
                }
              }
   
  
              else if(v.key === "background") {
                 if(device === "desktop" && data.properties["backgroundWeb"] !== undefined){
                  if(data.properties.backgroundWeb) {
                    if(data.properties.overlayColorWeb && data.properties.overlayColorWeb !== ""){
                      style[v.key] = elementBackground(data.properties.backgroundWeb, data.properties.backgroundWebType, data.properties.overlayColorWeb);
                    }else{
                      style[v.key] = elementBackground(data.properties.backgroundWeb, data.properties.backgroundWebType);
                    }  
                  }
                }else{
                  if(v.value === "iconBackground") { 
                    if(value) { 
                      if(device === "desktop" && data.properties["iconBackgroundWeb"] !== undefined){
                        style["background"] = app.getColor(data.properties.iconBackgroundWeb); 
                      }
                      else{
                        style[v.key] = app.getColor(value);
                      } 
                    }
                  }
                  else { 
                    if(value) {
                      if(data.properties.overlayColor && data.properties.overlayColor !== ""){
                        style[v.key] = elementBackground(value, data.properties.backgroundType, data.properties.overlayColor);
                      }else{
                        style[v.key] = elementBackground(value, data.properties.backgroundType);
                      } 
                    }
                  }
                }
                
              }
  
              
              else if(v.key === "borderBottom") {
                let type = data.properties["dividerType"];
                if(type === 'line'){
                  type = "solid"
                }else if(type === 'dash'){
                  type = "dashed"
                }
                if(data.properties["enableDivider"]){
                  style[v.key] = value+'px '+type+' '+app.getColor(data.properties["dividerColor"]); 
                }
                
              } 
              else if(v.key === "border") {
                let type = data.properties["borderType"];
                if(type === 'line'){
                  type = "solid"
                }else if(type === 'dash'){
                  type = "dashed"
                }
                if(data.properties["borderColor"]){
                  style[v.key] = value+'px '+type+' '+app.getColor(data.properties["borderColor"]); 
                } 
              }
              else if(v.key === "buttonBorder") { 
                if(data.properties["borderColor"]){
                  style["border"] = '1px solid '+app.getColor(data.properties["borderColor"]); 
                } 
              }
              else if(v.key === "borderRadius") {
                style[v.key] = elementPadding(data.properties["borderCorners"]);
                style['overflow'] = 'overflow-hidden'; 
              }
              
              else if(v.key === "borderWidget") { 
                let type = data.properties["borderType"];
                if(type === 'line'){
                  type = "solid"
                }else if(type === 'dash'){
                  type = "dashed"
                }
                if(data.properties["borderColor"]){ 
                  style['borderWidth'] = value !== undefined ? elementPadding(value) : 0; 
                  style['borderStyle'] = type; 
                  style['borderColor'] = app.getColor(data.properties["borderColor"]); 
                } 
              }
  
              else if(v.key === "logoDimension") {  
                if(data.properties["logoDimension"]){ 
                  style['width'] = value+'px';   
                } 
              }
  
              else if(v.key === "boxShadow") {   
                if(data.properties.fixedPosition && data.properties.dropShadow){  
                  style['boxShadow'] = `0px ${data.properties.dropShadowDistance}px ${data.properties.dropShadowBlur}px  ${data.properties.dropShadowSpread}px ${app.getColor(data.properties.dropShadowColor)}`;   
                } 
              } 
  
            })
          }
          return style;
        },
        getClass:function(data, device) {
          if(!data) {
            return "";
          }
          const style = [data.viewType];
          if(elementsClass[data.viewType]) { 
            elementsClass[data.viewType].forEach(function(v){ 
              const value = data.properties[v]; 
              let settingsValue = '';
              if(data.settings){
                settingsValue = data.settings[v];
              }
  
              if(v === "showWeb") { 
                if(value === false) { 
                  style.push("desktop-d-none")
                }
              }
              if(v === "show") { 
                if(value === false) {
                  style.push("mobile-d-none")
                }
              } 
  
              if(v === "fixedPosition" && app.getDevice()) {  
                if(value === true) {
                  style.push("position-fixed");
                  style.push("header-fixed")
                }
              } 
  
              if(v === "textAlignment") {
                if(value === "start") {
                  style.push("text-start")
                }
                if(value === "center") {
                  style.push("text-center")
                }
                if(value === "end") {
                  style.push("text-end")
                }
                if(value === "justify") {
                  style.push("text-justify")
                }
              }
              if(v === "itemAlignment") {
                if(value === "start") {
                  style.push("text-start")
                }
                if(value === "center") {
                  style.push("text-center")
                }
                if(value === "end") {
                  style.push("text-end")
                }
                if(value === "justify") {
                  style.push("text-justify")
                }
              }   
              
              if(!app.getDevice()){  // As per Tester he want show all change for Mobile so I add info icon and hide funcanility
                  if(v === "isBlurImage"){ 
                    // if(settingsValue === true) { 
                    //   style.push("isBlurImage")
                    // }
                  }
                // if(v === "isText"){ 
                //   if(settingsValue === false) { 
                //     style.push("isText")
                //   }
                // }
                if(v === "hideHeader"){ 
                  // if(settingsValue === true) { 
                  //   style.push("hideHeader")
                  // }
                }
                
              }
              
  
            })
          }
          return style.join(" ");
        },
}

const string2parse = function(data) { 
  if (typeof data === 'string') {
      try {
          return JSON.parse(data); 
      } catch (e) {
          console.error('Invalid JSON string:', e);
          return data; 
      }
  }

  // If data is already parsed (not a string), return it as-is
  return data;
}

export const elementsStyle = {
    "view":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"},
        {key:"color", value:"textColor"},
        {key:"borderBottom", value:"dividerSize"},
        {key:"boxShadow", value:"dropShadow"}
    ],
   
    "socialLinks":[
        {key:"padding", value:"paddingWeb"},
        {key:"background", value:"background"},
        {key:"margin", value:"marginWeb"},
    ], 
   
    "button":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},
        {key:"background", value:"background"}, 
        {key:"padding", value:"paddingWeb"},
        {key:"buttonBorder", value:"borderColor"},
    ],
    
    "navigation":[ 
        {key:"fontFamily", value:"fontFamily", type:"fontType"}, 
        {key:"fontSize", value:"textSizeWeb", type:"fontType"}, 

        {key:"color", value:"textColor", type:"colorType"}, 
        {key:"background", value:"background", type:"colorType"},

        {key:"borderWidget", value:"borderWidget", type:"borderType"},
        {key:"borderRadius", value:"borderCorners", type:"borderType"}, 

        {key:"padding", value:"paddingWeb", type:"spacingType"},

        {key:"textColorClick", value:"textColorClick"},  
        {key:"backgroundClick", value:"backgroundClick"}, 

        {key:"textColorHover", value:"textColorHover"},  
        {key:"backgroundHover", value:"backgroundHover"}, 
    ],
    
    "logo":[
        {key:"fontFamily", value:"fontFamily"},
        {key:"color", value:"textColor"}, 
        {key:"fontSize", value:"textSizeWeb"},  
        {key:"padding", value:"paddingWeb"}
    ],
    "advanceSocialLinks":[
        {key:"color", value:"iconColor"}, 
        {key:"activeColor", value:"activeColor"}, 
        {key:"background", value:"iconBackground"},
        {key:"fontSize", value:"iconSizeWeb"},
        {key:"iconTextColor", value:"iconTextColor"}, 
        {key:"iconTextBgColor", value:"iconTextBgColor"}, 
        {key:"padding", value:"paddingWeb"}, 
    ]
    
}

export const elementsClass = {
    "view":["show", "itemAlignment", "isFlipped", "fixedPosition", "isBlurImage", "hideHeader"],
    "socialLinks":["show","showWeb"], 
    "button":["show","showWeb"],
    "advanceSocialLinks":["show","showWeb"],
}

export const HeaderAi = function(props) {  
  const data = string2parse(props.data) 
     
  
  let style = `
    #navigation li a{
        color:${app.getColor(data.elements.navigation.properties.textColor)} !important;
        border-color:${app.getColor(data.elements.navigation.properties.borderColor)} !important;
    } 
    #navigation li.active a{
        background:${app.getColor(data.elements.navigation.properties.backgroundClick)} !important;
        color:${app.getColor(data.elements.navigation.properties.textColorClick)} !important;
        border-color:${app.getColor(data.elements.navigation.properties.borderColorClick)} !important;
    } 
    #navigation li:hover a {
        background:${app.getColor(data.elements.navigation.properties.backgroundHover)} !important;
        color:${app.getColor(data.elements.navigation.properties.textColorHover)} !important;
        border-color:${app.getColor(data.elements.navigation.properties.borderColorHover)} !important;
    }

    #navigation li.dropdown .dropdown-menu {
      background:${app.getColor(data.elements.navigation.properties.submenuBackground)} !important;
    }

    [widget-type="headerAi"] .dropdown-style-grid {
        column-rule: 0.1px solid ${app.getColor(data.elements.navigation.properties.submenuTextColor)} !important;
    }

    #navigation li.dropdown .dropdown-menu li a.dropdown-item {
      background:${app.getColor(data.elements.navigation.properties.submenuBackground)} !important;
      color:${app.getColor(data.elements.navigation.properties.submenuTextColor)} !important;
    }

    #navigation li.dropdown .dropdown-menu li a.dropdown-item:hover{
      background:${app.getColor(data.elements.navigation.properties.submenuBackgroundHover)} !important;
      color:${app.getColor(data.elements.navigation.properties.submenuTextColorHover)} !important;
    }
    `

  let containerWidth = "container-fluid"
  if(data.properties.isFluid === "container"){
      containerWidth = "container"
  }

  const {logo, socialIcons, primaryButton, navigation} = data.elements;
  let allPages = [];
  if(localStorage.getItem("pages")) {
    allPages = JSON.parse(localStorage.getItem("pages"));
  }

  return <header className={`shadow-sm p-0 ${containerWidth} ${app.getClass(data)}`} style={app.getStyle(data)}>
  <style>

  {`${style}
  `}
  </style>
  <div className="container">
    <div className="row align-items-center py-2">
      {/* Left Column: Logo + Title */}
      <div className="col-auto d-flex align-items-center elements">
        <img src={logo.properties.src} alt="Logo" className="me-2 rounded-circle" style={{height:logo.properties.logoDimension + "px"}} />
        <span className={app.getClass(logo)} style={app.getStyle(logo)}>{logo.text}</span>
      </div>
      {/* Center Column: Navigation */}
      <div className={`col elements ${app.getClass(navigation)}`} id="navigation" style={app.getStyle(navigation)}>
        <ul className="nav justify-content-center">
          {
            allPages.map(function(v, i){
              let active = "";
              if(i === 0) {
                active = "active";
              }
              return <li className={`nav-item ${active}`}><a className={`nav-link`} href="#">{v.name}</a></li>
            })
          }
          
        </ul>
      </div>
      {/* Right Column: Icons + Button */}
      <div className={`col-auto d-flex align-items-center`}>
        <div className={`elements ${app.getClass(socialIcons)}`} style={app.getStyle(socialIcons)}>
          {
          socialIcons.options.map(function(v){
            return <a href={v.link} target={v.target} className="text-dark me-3"><i className={`fa ${v.iconCss}`} /></a>
          })
          
        }
        </div>
        <a className="btn btn-primary rounded-pill px-4 elements" style={app.getStyle(primaryButton)}>{primaryButton.text}</a>
      </div>
    </div>
  </div>
</header>

}
export default HeaderAi;